import { render, staticRenderFns } from "./AcademicBankTile.vue?vue&type=template&id=1934c684"
import script from "./AcademicBankTile.vue?vue&type=script&lang=js"
export * from "./AcademicBankTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports